export default __webpack_public_path__ + "static/media/binance.ddf3c061.png";